import React, { useState, useEffect } from 'react';
import api from '../services/api';

function CreateEventModal({ onCreated, onClose }) {
  const [areas, setAreas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [event, setEvent] = useState({
    event_name: '',
    event_date: '',
    target_participants: '',
  });
  const [targets, setTargets] = useState({});

  useEffect(() => {
    const loadAreas = async () => {
      const res = await api.getAreas();
      if (res.success) {
        setAreas(res.areas || []);
        // Inizializza targets vuoti per ogni area
        const initialTargets = {};
        (res.areas || []).forEach(a => {
          initialTargets[a.id] = 0;
        });
        setTargets(initialTargets);
      }
    };
    loadAreas();
  }, []);

  function handleChange(e) {
    setEvent({ ...event, [e.target.name]: e.target.value });
  }

  function handleTargetChange(areaId, value) {
    setTargets({ ...targets, [areaId]: Number(value) || 0 });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      // Prepara area_targets array
      const area_targets = Object.entries(targets).map(([area_id, target]) => ({
        area_id: Number(area_id),
        target: Number(target)
      }));

      const res = await api.createEvent({
        event_name: event.event_name,
        event_date: event.event_date,
        target_participants: Number(event.target_participants),
        area_targets
      });

      console.log('Create event response:', res);

      if (res.success) {
        onCreated(); // Aggiorna lista
        onClose();   // Chiudi modal
      } else {
        alert(res.error || 'Errore creazione evento');
      }
    } catch (err) {
      console.error('Create event error:', err);
      alert('Errore di connessione');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="modal show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg">
        <form className="modal-content" onSubmit={handleSubmit}>
          <div className="modal-header">
            <h5 className="modal-title">Crea Nuovo Evento</h5>
            <button type="button" className="btn-close" onClick={onClose} disabled={loading} />
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label">Nome Evento</label>
              <input 
                name="event_name" 
                className="form-control" 
                placeholder="Es. Evento Milano 2025"
                value={event.event_name} 
                onChange={handleChange} 
                required 
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Data Evento</label>
              <input 
                type="date" 
                name="event_date" 
                className="form-control"
                value={event.event_date} 
                onChange={handleChange} 
                required 
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Partecipanti Previsti (Totale)</label>
              <input 
                type="number" 
                name="target_participants" 
                className="form-control"
                placeholder="Es. 50"
                value={event.target_participants}
                onChange={handleChange} 
                required 
              />
            </div>

            <h6 className="mb-3">Obiettivo Partecipanti per Area</h6>
            {areas.length === 0 ? (
              <p className="text-muted">Caricamento aree...</p>
            ) : (
              <div className="row">
                {areas.map(area => (
                  <div key={area.id} className="col-md-6 mb-3">
                    <label className="form-label">{area.name}</label>
                    <input
                      type="number"
                      className="form-control"
                      min={0}
                      value={targets[area.id] || 0}
                      onChange={e => handleTargetChange(area.id, e.target.value)}
                      placeholder="0"
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button 
              type="button" 
              className="btn btn-secondary" 
              onClick={onClose}
              disabled={loading}
            >
              Annulla
            </button>
            <button 
              className="btn btn-success" 
              type="submit"
              disabled={loading}
            >
              {loading ? 'Creazione...' : 'Crea Evento'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateEventModal;
